// extracted by mini-css-extract-plugin
module.exports = {"obs-question-message":"obs-question-message-310c102e49e34b8ad279221d811a41e0","upload-tips-text":"upload-tips-text-64124cc5a10723d935a561c34bc410a1"};